import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { TenderType } from './tender-type';
import Method from './method';
export default ProtoBaseModel.extend({
  type: attr(TenderType),
  method: attr(Method)
});